import { ReactElement } from 'react';
import { DataGridToolbarActions } from 'components/common/dataGrid/DataGridToolbarActions';

export function ContractDataGridActions(): ReactElement {
  return <DataGridToolbarActions columnsDataQa='contract-table-column-settings-button' />;
}
